export enum DownloadExcelScreen {
    DOWNLOAD_EXCEL_ERROR,
    DOWNLOAD_EXCEL_LOADING,
    DOWNLOAD_EXCEL_AVAILABLE,
    DOWNLOAD_EXCEL_TOO_MANY_COLUMNS,
}
